import { createContext } from 'react';

import type { S_INDEX_TABLE_SELECT_ALL_ITEMS, SIndexTableRange, SIndexTableSelectionType } from './types';

export interface SIndexTableContextType {
    loading?: boolean;
    bulkSelectState?: boolean | 'indeterminate';
    resourceName: {
        singular: string;
        plural: string;
    };
    selectedItemsCount: typeof S_INDEX_TABLE_SELECT_ALL_ITEMS | number;
    bulkActionsAccessibilityLabel?: string;
    selectMode: boolean;
    paginatedSelectAllText?: string;
    itemCount: number;
    selectable?: boolean;
    hasMoreItems?: boolean;
    condensed?: boolean;
    disableSelection?: boolean;
}

export const SIndexTableContext = createContext<SIndexTableContextType | undefined>(undefined);

export const SIndexTableSelectionChangeContext = createContext<
    | ((
          selectionType: SIndexTableSelectionType,
          toggleType: boolean,
          selection?: string | SIndexTableRange,
          position?: number
      ) => void)
    | undefined
>(undefined);
